/**
 *
 * @module bifThumbnailSet
 *
 */

import ThumbnailSet from './thumbnailSet';

/**
 *
 * @class BifThumbnailSet
 * @extends {SDK.Services.Media.ThumbnailSet}
 *
 */
export default class BifThumbnailSet extends ThumbnailSet {

    /**
     *
     * @param {Object} options
     * @param {Number} options.thumbnailWidth
     * @param {Number} options.thumbnailHeight
     * @param {Number} options.intervalMilliseconds
     * @param {Number} options.totalBytes
     * @param {Array<SDK.Services.Media.Presentation>} options.presentations
     * @note params are type checked and assigned in the base class
     *
     */
    constructor(options) {

        super(options);

    }

}



// WEBPACK FOOTER //
// ./src/services/media/bifThumbnailSet.js